import * as v from 'valibot';
import { IdSchema, TimestampSchema } from './common.js';
export const FileVersionSchema = v.object({
    id: IdSchema,
    fileId: IdSchema,
    versionNumber: v.pipe(v.number(), v.integer(), v.minValue(1)),
    r2Key: v.pipe(v.string(), v.minLength(1)),
    createdAt: TimestampSchema,
    deletedAt: v.optional(TimestampSchema)
});
export const FileSchema = v.object({
    id: IdSchema,
    folderId: IdSchema,
    parentId: v.optional(v.nullable(IdSchema)),
    kind: v.optional(v.literal('file')),
    roomId: IdSchema,
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    currentVersion: v.pipe(v.number(), v.integer(), v.minValue(1)),
    r2Key: v.pipe(v.string(), v.minLength(1)),
    mimeType: v.pipe(v.string(), v.minLength(1)),
    sizeBytes: v.pipe(v.number(), v.integer(), v.minValue(0)),
    displayNumber: v.pipe(v.string(), v.minLength(1)),
    sortOrder: v.pipe(v.number(), v.integer(), v.minValue(0)),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
    deletedAt: v.optional(v.nullable(TimestampSchema)),
    uploadCommittedAt: v.optional(v.nullable(TimestampSchema))
});
const MAX_UPLOAD_SIZE_BYTES = 5 * 1024 * 1024 * 1024; // 5 GiB
export const InitUploadSchema = v.object({
    roomId: IdSchema,
    folderId: v.optional(IdSchema),
    parentId: v.optional(IdSchema),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    mimeType: v.pipe(v.string(), v.minLength(1)),
    sizeBytes: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(MAX_UPLOAD_SIZE_BYTES))
});
export const ConfirmUploadSchema = v.object({
    fileId: IdSchema,
    r2Key: v.pipe(v.string(), v.minLength(1))
});
export const RestoreFileSchema = v.object({
    fileId: IdSchema,
    versionNumber: v.pipe(v.number(), v.integer(), v.minValue(1))
});
export const UpdateFileSchema = v.partial(v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255))
}));
export const InitMultipartSchema = v.object({
    roomId: IdSchema,
    folderId: v.optional(IdSchema),
    parentId: v.optional(IdSchema),
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    mimeType: v.pipe(v.string(), v.minLength(1)),
    sizeBytes: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(MAX_UPLOAD_SIZE_BYTES))
});
const MAX_PART_BASE64_CHARS = 33_554_432; // ~33 MiB base64 ≈ 25 MiB raw
export const UploadPartSchema = v.object({
    fileId: IdSchema,
    uploadId: v.pipe(v.string(), v.minLength(1)),
    partNumber: v.pipe(v.number(), v.integer(), v.minValue(1)),
    data: v.pipe(v.string(), v.minLength(1), v.maxLength(MAX_PART_BASE64_CHARS))
});
const MAX_PARTS = 10_000;
export const CompleteMultipartSchema = v.object({
    fileId: IdSchema,
    uploadId: v.pipe(v.string(), v.minLength(1)),
    parts: v.pipe(v.array(v.object({
        partNumber: v.pipe(v.number(), v.integer(), v.minValue(1)),
        etag: v.pipe(v.string(), v.minLength(1))
    })), v.maxLength(MAX_PARTS))
});
//# sourceMappingURL=file.js.map